import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
  EnvelopeClosedIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
} from '@radix-ui/react-icons';
import { Button } from '../../components';
import { AuthLayout } from './AuthLayout';
import './Auth.scss';

interface LocationState {
  email?: string;
}

export const ResetLinkSent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as LocationState | null)?.email?.trim() ?? '';

  if (!email) {
    return (
      <AuthLayout>
        <div className="auth-card">
          <h1 className="auth-title auth-title--center">Reset Link Not Found</h1>
          <p className="auth-subtitle auth-subtitle--center">
            Request a password reset link to continue.
          </p>
          <Button
            type="button"
            fullWidth
            className="auth-submit-button"
            onClick={() => navigate('/reset-password')}
          >
            Reset Password
            <ArrowRightIcon aria-hidden="true" />
          </Button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout tagline="Your day, organized. Your goals, within reach.">
      <div className="auth-card">
        <div className="auth-success-icon auth-success-icon--email" aria-hidden="true">
          <EnvelopeClosedIcon />
        </div>

        <h1 className="auth-title auth-title--center">Check Your Email</h1>
        <p className="auth-subtitle auth-subtitle--center">
          If an account exists for{' '}
          <span className="auth-email-highlight">{email}</span>, we&apos;ve sent a password reset
          link. Open the link in your inbox to choose a new password.
        </p>

        <ul className="auth-checklist">
          <li>Check your spam or junk folder if you don&apos;t see the email.</li>
          <li>For your security, the reset link is only valid for 10 minutes—use it soon or request a new one.</li>
        </ul>

        <Button
          type="button"
          fullWidth
          className="auth-submit-button"
          onClick={() => navigate('/login', { state: { email } })}
        >
          Back to Login
          <ArrowRightIcon aria-hidden="true" />
        </Button>

        <Link
          to="/reset-password"
          state={{ email }}
          className="auth-back-link"
        >
          <ArrowLeftIcon aria-hidden="true" />
          Didn&apos;t receive it? Try again
        </Link>
      </div>
    </AuthLayout>
  );
};
